<template>
  <div class="device-setting-preview-component" data-grm-comp="DeviceSettingPreview" :class="{ inRoom: !isDevicetest }">
    <div class="device-setting-preview">
      <div class="device-set-preview">
        <div class="device-set-preview-header">
          <div class="device-set-preview-title-wrapper">
            <a v-if="isDevicetest" href="service/room" class="back-btn mobile"></a>
            <h1 class="device-set-preview-title"
                v-if="isDevicetest">{{ $t("deviceSetting.preview.device.test") }}</h1>
            <p class="device-set-preview-title"
               v-if="!isDevicetest">{{ $t("deviceSetting.preview.device.setting") }}</p>
            <GrmCloseBtn v-if="!isDevicetest" @click="onClose" />
            <button v-if="isDevicetest" class="device-set-info-show-btn mobile" @click="$emit('onToggleInfo')">{{ $t("common.info") }}</button>
          </div>
        </div>
        <div class="device-set-preview-body">
          <div v-if="!isIOS || (isIOS && isDevicetest)" class="device-set-preview-video-container rounded-lg overflow-hidden">
            <div class="device-set-preview-video-wrapper rounded-lg relative overflow-hidden"
                 :class="[
                     { 'error': selectedDevice.video.state === 'error' }
                   ]">
              <video autoplay muted playsinline class="device-set-preview-video rounded-lg bg-black previewVideo"
                     :class="{ mirror: selectedDevice.video.usePreviewMirror }"
                     ref="preview_video"></video>
              <transition name="fade">
                <GrmLoadingCircle v-if="selectedDevice.video.state === 'loading'"
                                  class="rounded-lg bg-black bg-opacity-50 absolute inset-0"
                />
              </transition>
            </div>
            <div class="device-set-preview-status">
              <div class="device-set-preview-status-header">
                <div v-if="isDevicetest && isShowDeviceInfo" class="device-set-preview-status-warning-wrapper">
                  <p class="device-set-preview-status-warning">{{ defaultDeviceInfo }}</p>
                </div>
              </div>
              <div class="device-set-preview-status-footer">
                <div class="device-set-preview-status-controls">
                  <button class="device-set-preview-status-control mic micStatus"
                          :class="{ off: selectedDevice.audio.state === 'error' }"></button>
                  <button class="device-set-preview-status-control camera cameraStatus"
                          :class="{ off: selectedDevice.video.state === 'error' }"></button>
                </div>
              </div>
            </div>
          </div>
          <div class="device-set-preview-options-container optionsContainer">
            <div class="device-set-preview-options-header">
              <div class="device-set-preview-options-tabs" :class="selectedTab">
                <button class="device-set-preview-options-tab-btn video" @click="selectedTab = 'video'">{{ $t("common.video") }}</button>
                <button class="device-set-preview-options-tab-btn audio" @click="selectedTab = 'audio'">{{ $t("common.audio") }}</button>
              </div>
            </div>
            <div class="device-set-preview-options-body">
              <div class="device-set-preview-option-contents"
                   v-show="selectedTab === 'video'">
                <div class="device-set-preview-option-section">
                  <div class="device-set-preview-option-header">
                    <div class="device-set-preview-option-title-wrapper">
                      <h3 class="device-set-preview-option-title">{{ $t("common.device.camera") }}</h3>
                    </div>
                  </div>
                  <div class="device-set-preview-option-body">
                    <div class="device-set-preview-option-select-wrapper">
                      <select class="form-select"
                              v-model="selectedDevice.video.deviceId"
                              @input="onChangeDevice('video', $event.target.value)">
                        <option v-for="device in devices.videoinput"
                                :value="device.deviceId"
                                :key="device.deviceId">{{device.label}}</option>
                      </select>
                    </div>
                    <div class="device-set-preview-option-video-mirror-container">
                      <div class="toggle-btn-container">
                        <input type="checkbox"
                               name="video-mirror"
                               id="video-mirror"
                               class="toggle-btn"
                               :checked="selectedDevice.video.usePreviewMirror"
                               @input="togglePreviewMirror"
                        />

                        <label for="video-mirror" class="toggle-label">
                          <span class="toggle-label-text">{{ $t("deviceSetting.preview.videoReverse") }}</span>
                          <div class="toggle-status"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="device-set-preview-option-section">
                  <div class="device-set-preview-option-header">
                    <div class="device-set-preview-option-title-wrapper">
                      <h3 class="device-set-preview-option-title">
                        {{ $t("deviceSetting.preview.virtualBackground.title") }}
                        <span class="device-set-preview-option-beta"><img src="@/assets/images/beta_blue.svg" /></span>
                      </h3>
                      <p class="device-set-preview-option-description">{{ $t("deviceSetting.preview.quality") }}</p>
                    </div>
                  </div>
                  <div class="device-set-preview-option-body">
                    <div class="device-set-preview-option-virtual-background-container virtualBackgroundContainer">
                      <button
                          class="device-set-preview-option-virtual-background-btn none"
                          :class="{ selected: selectedDevice.video.virtualBackgroundType === 'none' }"
                          @click="onChangeVirtualBackground('none')"
                      />
                      <button
                          class="device-set-preview-option-virtual-background-btn blur"
                          :class="{ selected: selectedDevice.video.virtualBackgroundType === 'blur' }"
                          @click="onChangeVirtualBackground('blur')"
                      >
                        <div class="coach-mark-preview-virtual-background blur mobile" v-if="isShowCoachmark">
                          <div class="coach-mark-guide blur mobile">
                            <div class="coach-mark-guide-arrow">
                              <img src="@/assets/images/coachmark/coachmark_arrow_blue_07.svg" alt="coach-mark-guide-arrow">
                            </div>
                            <div class="coach-mark-guide-text-container">
                              <p class="coach-mark-guide-text">{{ $t("deviceSetting.preview.virtualBackground.select") }}</p>
                            </div>
                          </div>
                        </div>
                      </button>
                      <button
                          class="device-set-preview-option-virtual-background-btn inside_01"
                          :class="{ selected: selectedDevice.video.virtualBackgroundType === 'inside_01' }"
                          @click="onChangeVirtualBackground('inside_01')"
                      />
                      <button
                          class="device-set-preview-option-virtual-background-btn inside_02"
                          :class="{ selected: selectedDevice.video.virtualBackgroundType === 'inside_02' }"
                          @click="onChangeVirtualBackground('inside_02')"
                      />
                      <button
                          class="device-set-preview-option-virtual-background-btn inside_03"
                          :class="{ selected: selectedDevice.video.virtualBackgroundType === 'inside_03' }"
                          @click="onChangeVirtualBackground('inside_03')"
                      />
                      <button
                          class="device-set-preview-option-virtual-background-btn inside_04"
                          :class="{ selected: selectedDevice.video.virtualBackgroundType === 'inside_04' }"
                          @click="onChangeVirtualBackground('inside_04')"
                      />
                      <button
                          class="device-set-preview-option-virtual-background-btn outside_01"
                          :class="{ selected: selectedDevice.video.virtualBackgroundType === 'outside_01' }"
                          @click="onChangeVirtualBackground('outside_01')"
                      />
                      <button
                          class="device-set-preview-option-virtual-background-btn outside_02"
                          :class="{ selected: selectedDevice.video.virtualBackgroundType === 'outside_02' }"
                          @click="onChangeVirtualBackground('outside_02')"
                      />
                      <div class="device-set-preview-option-virtual-background-btn-wrapper custom"
                           :class="{ selected: selectedDevice.video.virtualBackgroundType === 'custom' }"
                           :style="virtualBackgroundCustomStyle">
                        <input type="file" accept="image/*" name="add-virtual-background" id="add-virtual-background" style="display: none"
                               @input="onChangeVirtualBackgroundUrl" />
                        <button class="device-set-preview-option-virtual-background-btn apply"
                                :class="{ selected: selectedDevice.video.virtualBackgroundType === 'custom' }"
                                @click="onChangeVirtualBackground('custom')" />
                        <label for="add-virtual-background" class="device-set-preview-option-virtual-background-btn custom"
                               v-show="!selectedDevice.video.virtualBackgroundUrl"></label>
                        <label for="add-virtual-background" class="device-set-preview-option-virtual-background-btn change"
                               v-show="selectedDevice.video.virtualBackgroundUrl">{{ $t("common.change") }}</label>
                      </div>
                    </div>
                  </div>
                  <div v-if="!isVirtualBgAvailable" class="device-set-preview-option-disabled-wrapper">
                    <p class="device-set-preview-option-disabled-text" v-html="virtualBgAvailableText"></p>
                  </div>
                </div>
              </div>
              <div class="device-set-preview-option-contents"
                   v-show="selectedTab === 'audio'">
                <div class="device-set-preview-option-section">
                  <div class="device-set-preview-option-header">
                    <div class="device-set-preview-option-title-wrapper">
                      <h3 class="device-set-preview-option-title">{{ isIOS || isSafari ? $t('deviceSetting.preview.micNspeaker.title') : $t('common.device.mic') }}</h3>
                    </div>
                  </div>
                  <div class="device-set-preview-option-body">
                    <div class="device-set-preview-option-select-wrapper">
                      <select class="form-select" v-model="selectedDevice.audio.deviceId" @input="onChangeDevice('audio', $event.target.value)">
                        <option v-for="device in devices.audioinput" :value="device.deviceId" :key="device.deviceId">{{device.label}}</option>
                      </select>
                    </div>
                    <div class="device-set-preview-option-mic-volume-wrapper">
                      <div class="device-set-preview-option-mic-volume overflow-hidden">
                        <div class="device-set-preview-option-mic-volume-fill"
                             :style="`transform: scaleX(${selectedDevice.audio.volume})`"
                        ></div>
                      </div>
                    </div>
                    <div class="device-set-preview-option-deep-hearing-container">
                      <div class="toggle-btn-container">
                        <input type="checkbox" name="deep-hearing" id="deep-hearing" class="toggle-btn deepHearing"
                               v-model="selectedDevice.audio.useNoiseCancel"
                               @input="toggleNoiseCancel"/>
                        <label for="deep-hearing" class="toggle-label">
                          <div class="toggle-info">
                            <span class="toggle-label-text deep-hearing">{{ $t("deviceSetting.preview.deepHearing.title") }}</span>
                            <div class="description-container">
                              <button class="description-btn">?</button>
                              <div class="description-modal">
                                <p class="description-text">{{ $t("deviceSetting.preview.deepHearing.text") }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="toggle-status"
                            :class="{disabled: !isNoiseCancelAvailable}"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="devices.audiooutput?.length" class="device-set-preview-option-section">
                  <div class="device-set-preview-option-header">
                    <div class="device-set-preview-option-title-wrapper">
                      <h3 class="device-set-preview-option-title">{{ $t("common.device.speaker") }}</h3>
                    </div>
                  </div>
                  <div class="device-set-preview-option-body">
                    <div class="device-set-preview-option-select-wrapper">
                      <select class="form-select" v-model="selectedDevice.audiooutput.deviceId" @input="onChangeDevice('audiooutput', $event.target.value)">
                        <option v-for="device in devices.audiooutput" :value="device.deviceId" :key="device.deviceId">{{device.label}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div v-if="isDevicetest && !isSafari" class="device-set-preview-option-section">
                  <div class="device-set-preview-option-mic-speaker-test-btn-wrapper">
                    <button
                      class="device-set-preview-option-mic-speaker-test-btn"
                      @click="onToggleAudioTest"
                    >{{ $t("deviceSetting.preview.micNspeaker.test") }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="device-set-preview-help-container">
          <p class="device-set-preview-help-text">{{ $t("deviceSetting.preview.device.problem") }}</p>
          <a target="_blank" href="https://bizguide.gooroomee.com/efc908fc-baa8-4a02-bbb1-48645a5e5d2b" class="device-set-preview-help-link">{{ $t("deviceSetting.preview.settingGuide") }}</a>
        </div>
        <div class="device-set-preview-footer">
          <div v-if="isDevicetest" class="device-set-preview-join-room-btn-wrapper mobile">
            <button class="default-btn join-request-btn"
                    @click="join"
            >{{ joinText }}</button>
            <a class="default-btn home" href="/service/room">{{ $t("deviceSetting.preview.toHome") }}</a>
            <ul class="loading-obj-group">
              <li class="loading-obj obj-1"></li>
              <li class="loading-obj obj-2"></li>
              <li class="loading-obj obj-3"></li>
              <li class="loading-obj obj-4"></li>
            </ul>
          </div>
          <div v-else class="device-set-preview-join-room-btn-wrapper rounded relative overflow-hidden">
            <button class="default-btn"
                    @click="applyChangedDevice">{{ $t('common.save') }}</button>
            <transition name="fade">
              <GrmLoadingCircle v-if="selectedDevice.video.state === 'loading'"
                                class="bg-black bg-opacity-50 absolute inset-0"
              />
            </transition>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <DeviceSettingAudioTest
          class="device-setting-audio-test-component"
          ref="audioTest"
          v-if="isShowAudioTest"
          :audio="selectedDevice.audio"
          :audiooutput="selectedDevice.audiooutput"
          @onToggleAudioTest="onToggleAudioTest"
      />
    </transition>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";

import { Room } from '@/core/api/room.api'
import {GrmWebRTC} from "@/lib/gooroomee/webrtc/GrmWebRTC";
import {RoomMediapipe} from "@/lib/gooroomee/mediapipe/grm-mediapipe";
import {grmNoiseCancel} from "@/lib/gooroomee/noisecancel/GrmNoiseCancel-1.0";

import {Device} from "@/utils";

import _ from "lodash";
import DetectRTC from "detectrtc";

import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn"
import GrmLoadingCircle from "@/components/Common/loading/GrmLoadingCircle";
import DeviceSettingAudioTest from '@/components/Room/DeviceSetting/AudioTest'

export default {
  name: 'DeviceSettingPreview',
  components: {
    GrmLoadingCircle,
    GrmCloseBtn,
    DeviceSettingAudioTest,
  },
  props: {
    roomInfo: Object,
    isShowCoachmark: Boolean,
    isDevicetest: Boolean,
  },
  data() {
    return {
      Device,
      selectedTab: 'video',
      isShowAudioTest: false,
      selectedDevice: {
        video: {
          showModal: false,
          state: 'ready', // loading, success, error
          deviceId: null,
          label: '',
          virtualBackgroundType: 'none',
          virtualBackgroundUrl: '',
          stream: null,
          proStream: null,
        },
        audio: {
          showModal: false,
          state: 'ready',
          deviceId: null,
          label: '',
          volume: 0,
          stream: null,
          proStream: null,
        },
        audiooutput: {
          showModal: false,
          state: 'ready',
          deviceId: null,
          label: '',
          volume: 0,
          isPaused: true
        },
      }
    }
  },
  async created() {
    this.SET_DEVICES(await GrmWebRTC.getUserDevice())

    if (this.deviceSettings) {
      ['video', 'audio', 'audiooutput'].forEach(device => {
        if (this.deviceSettings[device]) {
          this.selectedDevice[device] = Object.assign({}, this.selectedDevice[device], this.deviceSettings[device]);
        }
      })
    }

    await this.setDevices()
    this.validateVirtualBackground()
    if(!this.isNoiseCancelAvailable){
      this.selectedDevice.audio.useNoiseCancel = false;
    }
  },
  beforeDestroy() {
    this.stopMediaStream();
  },
  watch:{
    'selectedDevice.video.virtualBackgroundType': {
      immediate: false,
      handler: async function() {
        if(this.selectedDevice.video.virtualBackgroundType === 'custom'
            && this.selectedDevice.video.virtualBackgroundUrl.length < 1){
          this.onChangeVirtualBackground('none')
        }
        if(this.isInit)
          await this.preview('video', {deviceId: this.selectedDevice.video.deviceId})
      }
    }
  },
  computed: {
    ...mapState('waitingRoom', [
      'enabled',
      'roomClosed',
      'disapproved',
      'enterRequested',
      'noManagerInRoom',
      'deviceRequired'
    ]),
    ...mapGetters('room', [
      'devices',
      'deviceSettings',
      'roomInfoSetting',
      'noiseCancelAvailable',
    ]),
    getNecessarySettings(){
      let selected_devices = this.selectedDevice;
      const devices = this.devices;

      return _.merge({}, {
        video: {
          deviceId: (
            !devices.videoinput || devices.videoinput.length == 0
              ? null
              : devices.videoinput.find(d => (d.deviceId === selected_devices.video.deviceId) && selected_devices.video.state === 'success')
                ? selected_devices.video.deviceId
                : selected_devices.video.state === 'success'
                  ? devices.videoinput[0].deviceId
                  : null
          ),
          virtualBackgroundType: selected_devices.video.virtualBackgroundType,
          virtualBackgroundUrl: selected_devices.video.virtualBackgroundUrl,
          usePreviewMirror: selected_devices.video.usePreviewMirror,
        },
        audio: {
          deviceId: (
            !devices.audioinput || devices.audioinput.length == 0
              ? null
              : devices.audioinput?.find(d => (d.deviceId === selected_devices.audio.deviceId) && selected_devices.audio.state === 'success')
                ? selected_devices.audio.deviceId
                : selected_devices.audio.state === 'success'
                  ? devices.audioinput[0].deviceId
                  : null
          ),
          useNoiseCancel: selected_devices.audio.useNoiseCancel,
        },
        audiooutput: {
          deviceId: selected_devices.audiooutput.state === 'success' && selected_devices.audiooutput.deviceId,
        },
      })
    },
    isShowDeviceInfo() {
      return this.defaultDeviceInfo.length > 0
    },
    defaultRoleCamera() {
      return Room.RoomInfo.defaultRoleCamera()
    },
    defaultRoleMic() {
      return Room.RoomInfo.defaultRoleMic()
    },
    defaultDeviceInfo(){
      if(this.defaultRoleMic !== false && this.defaultRoleCamera !== false)
        return ''
      else if(this.defaultRoleMic === false && this.defaultRoleCamera)
        return this.$t('deviceSetting.preview.forbidden.mic')
      else if(this.defaultRoleMic && this.defaultRoleCamera === false)
        return this.$t('deviceSetting.preview.forbidden.camera')
      else(this.defaultRoleMic  === false && this.defaultRoleCamera  === false)
        return this.$t('deviceSetting.preview.forbidden.both')
    },
    virtualBackgroundCustomStyle() {
      return {
        background: `url(${this.selectedDevice.video.virtualBackgroundUrl}) no-repeat center / cover`,
      }
    },
    isNoiseCancelAvailable() {
      if(
        this.roomInfoSetting?.useNoiseCancel !== false &&
        (this.noiseCancelAvailable !== false && grmNoiseCancel?.isAvailable && grmNoiseCancel.isAvailable()) &&
        (!Device.isIOS() && !Device.isSafari())
      )
        return true;
      else
        return false;
    },
    isIOS() {
      return Device.isIOS();
    },
    isSafari() {
      return Device.isSafari();
    },
    joinText() {
      return this.enabled
        ? this.disapproved || this.noManagerInRoom || this.roomClosed
              ? this.$t('deviceSetting.preview.toHome')
              : this.enterRequested
                  ? this.$t('deviceSetting.preview.join.requested')
                  : this.$t('deviceSetting.preview.join.request')
        : this.$t('deviceSetting.preview.join.title');
    },
    isVirtualBgAvailable() {
      return this.roomInfoSetting?.useVirtualBg !== false && !this.isIOS && !this.isSafari;
      // return this.roomInfoSetting?.useVirtualBg !== false;
    },
    virtualBgAvailableText() {
      if(!this.roomInfoSetting?.useVirtualBg !== false){
        return this.$t('deviceSetting.preview.virtualBackground.notActivated');
      }else if(this.isIOS || this.isSafari){
        return this.$t('deviceSetting.preview.virtualBackground.notSupport');
      }else {
        return 'UNKNOWN';
      }
    },
  },
  methods: {
    ...mapMutations('room',[
      'SET_DEVICES',
    ]),
    ...mapMutations('waitingRoom',[
      'ENTER_REQUESTED',
    ]),
    ...mapActions('room',[
      'saveDeviceSettings'
    ]),
    validateVirtualBackground(){
      if(this.selectedDevice.video.virtualBackgroundUrl?.length){
        let type = this.selectedDevice.video.virtualBackgroundType;
        let img = new Image();
        img.src = this.selectedDevice.video.virtualBackgroundUrl;
        img.addEventListener('error', e => {
          let deviceSettings = {
            video: {
              virtualBackgroundUrl: '',
              virtualBackgroundType: type === 'custom' ? 'none' : type
            }
          }
          _.merge(this.selectedDevice, deviceSettings);
          this.saveDeviceSettings({deviceSettings});
        }, {once: true});
      }
    },
    async stopMediaStream(){
      await (async () => {
        let cnt = 0;
        let stream;
        for (let key in this.selectedDevice) {
          for (const k of ['oriStream', 'stream']) {
            stream = this.selectedDevice[key][k];
            if (stream && stream.getTracks().length > 0) {
              cnt++;
              await GrmWebRTC.stopMediaStream(stream);
            }
          }
        }
        console.log('# preview stream stopped. cnt :', cnt)
      })();
    },
    async applyChangedDevice(){
      await this.stopMediaStream();
      let deviceSettings = this.getNecessarySettings;
      this.changeDevice(deviceSettings);
      this.onClose();
    },
    changeDevice(deviceSettings) {
      for (let deviceType in deviceSettings) {
        const {deviceId, virtualBackgroundType, useNoiseCancel} = deviceSettings[deviceType];
        this.$roomApi.Call.changeUserDevice({
          deviceType,
          deviceId,
          virtualBackgroundType,
          useNoiseCancel,
        })
      }

      this.saveDeviceSettings({deviceSettings});
    },
    resetVirtualBackground(){
      let deviceSettings = {
        video: {
          virtualBackgroundUrl: '',
          virtualBackgroundType: 'none'
        }
      }
      _.merge(this.selectedDevice, deviceSettings);
      this.saveDeviceSettings({deviceSettings});
    },
    onChangeVirtualBackground(type) {
      this.selectedDevice.video.virtualBackgroundType = type;
    },
    async onChangeVirtualBackgroundUrl(e) {
      const files = e.target.files;
      if (files && files[0]) {
        const url = URL.createObjectURL(files[0])
        this.selectedDevice.video.virtualBackgroundUrl = url;
        if(this.selectedDevice.video.virtualBackgroundType === 'custom'){
          await this.preview('video', {deviceId: this.selectedDevice.video.deviceId})
        }else {
          this.onChangeVirtualBackground('custom')
        }
      }
      e.target.value = null;
    },
    async setDevices() {
      if (Device.isIOS() && !this.isDevicetest) {
        return;
      }

      this.SET_DEVICES(await GrmWebRTC.getUserDevice())

      if(!this.isInit) {
        this.isInit = true

        await Promise.all(['video', 'audio', 'audiooutput'].map(d => {
          this.preview(d, this.checkDevice(d))
        }))
      } else {
        await Promise.all(['video', 'audio', 'audiooutput'].map(d => {
          this.checkDevice(d);
        }))
      }
    },
    checkDevice(d){
      let list = this.devices[d + 'input'] || this.devices[d];
      if (!list || list.length === 0) {
        if (d === 'audiooutput' && (Device.isIOS() || Device.isSafari())) {
          this.selectedDevice[d] = { ...this.selectedDevice[d],  label: 'default',  deviceId: 'default' }
        } else {
          if (this.selectedDevice[d]) {
            this.selectedDevice[d].deviceId = null;
            this.selectedDevice[d].label = null;
          }
        }
        return;
      }

      let device = list[0]
      if (this.selectedDevice[d].deviceId) {
        let findDevice = list.find(l => l.deviceId === this.selectedDevice[d].deviceId)
        if (findDevice) {
          device = findDevice
        }
      }

      if (device) {
        Object.assign(this.selectedDevice[d], {
          deviceId: device.deviceId,
          label: device.label ? device.label : `${d}-0`,
          groupId: device.groupId
        })
      }
      return device;
    },
    async onChangeDevice(deviceType, deviceId) {
      console.log('# select device :', deviceType, deviceId)

      let device;
      if(deviceType === 'audiooutput'){
        device = this.devices[deviceType].find(e => e.deviceId == deviceId);
      }else{
        device = this.devices[deviceType + 'input'].find(e => e.deviceId == deviceId);
      }
      if(!device)
        return;

      let d = this.selectedDevice[deviceType]
      if (!d) return

      d.showModal = false

      if (d.deviceId === device.deviceId) {
        return
      }

      // d.deviceId = device.deviceId
      d.label = d === 'audiooutput' && (Device.isIOS() || Device.isSafari()) ? 'default' : device.label;

      // if (Device.isIOS() || Device.isSafari()) {
      //   return;
      // }

      await this.preview(deviceType, device)
    },
    async preview(deviceType, device = { deviceId: 'default'}) {
      if(!device){
        return;
      }
      let el = this.$refs['preview_' + deviceType]
      let d = this.selectedDevice[deviceType]
      if (!d) return

      d.state = 'loading'
      switch (deviceType) {
        case 'audiooutput':
          try {
            // if ((Device.isIOS() || Device.isSafari()) && !el.sinkId) {
              d.state = 'success';
              d.deviceId = device.deviceId;
              // return;
            // }
            // if (el.sinkId !== 'default') {
            //   await el.setSinkId('default');
            // }
            // if (el.setSinkId) {
            //   await el.setSinkId(device.deviceId);
            //   d.state = 'success';
            //   d.deviceId = device.deviceId;
            // }
          } catch(e) {
            console.error(el, e);
            d.state = 'error';
            d.deviceId = null;
          }
          break;
        case 'video':
        case 'audio': {
          try {
            let config = {}
            config[deviceType] = {
              deviceId: {exact: device.deviceId}
            }
            if (deviceType == 'video') {
              Object.assign(config[deviceType], { width: 640, height: 360 })
            }

            if (d.stream && d.deviceId != device.deviceId) {
              Promise.all([d.proStream, d.stream].map(stream => {
                if (stream)
                  GrmWebRTC.stopMediaStream(stream)
              }))
              d.stream = d.proStream = null;
            }

            if(!d.stream){
              d.deviceId = device.deviceId

              if (Device.isIOS() && !this.isDevicetest) {
                d.state = 'success';
                this.$emit('onUpdatePreview', {deviceType, device: this.selectedDevice[deviceType]});
                return;
              }

              if(this._gum_job){
                this._gum_job.config = Object.assign({}, this._gum_job.config, config);

                let stream = null;
                try{
                  stream = await new Promise((resolve, reject) => {
                    this._gum_job.resolveListeners.push(resolve);
                    this._gum_job.rejectListeners.push(reject);
                  });
                }catch(e) {
                  stream = await GrmWebRTC.getUserMedia(config)
                }

                if (!stream || !stream.getTracks().filter(t => t.kind === deviceType).length > 0) {
                  throw new Error('no stream');
                }

                d.stream = new MediaStream(
                    stream.getTracks().filter(t => t.kind === deviceType)
                );
              }else{
                this._gum_job = {
                  config,
                  resolveListeners: [],
                  rejectListeners: [],
                };
                d.stream = await new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    const job = this._gum_job;
                    try{
                      let stream = await GrmWebRTC.getUserMedia(job.config)
                      let s = new MediaStream(
                          stream.getTracks().filter(t => t.kind === deviceType)
                      );
                      job?.resolveListeners.forEach(r => r(stream));
                      resolve(s);
                    }catch(e){
                      try{
                        let stream = await GrmWebRTC.getUserMedia(config)
                        let s = new MediaStream(
                          stream.getTracks().filter(t => t.kind === deviceType)
                        );
                        resolve(s);
                      }catch (e) {
                        reject(e);
                      }finally {
                        job?.rejectListeners.forEach(r => r(e));
                      }
                    }finally {
                      delete this._gum_job;
                    }
                  }, 100);
                })
              }
            }

            if(this._isDestroyed){
              return this.stopMediaStream();
            }

            let stream = d.stream;
            if (el && deviceType == 'video') {
              if(this.isVirtualBgAvailable && this.selectedDevice.video.virtualBackgroundType !== 'none' ) {
                try{
                  stream = await this.setVirtualBackground(stream)
                  d.proStream = stream
                  if(this._isDestroyed) {
                    return this.stopMediaStream();
                  }
                }catch (e) {
                  console.warn('mediapipe failed', e)
                }
              }
              GrmWebRTC.attachMediaStream(el, stream)
              el.play().
                then(() => {
                  d.state = 'success'
                }).catch(() => {
                  console.log('this play is canceled')
                })
            }
            device.stream = stream;

            if (deviceType === 'audio') {
              GrmWebRTC.setAudioTrackVolumeEvent3(stream, ({volume}) => {
                d.volume = Math.min(volume, 100) / 100;
              })
              d.state = 'success';
            }

            if(this.isInit) {
              await this.setDevices()
            }
          } catch (e) {
            if(['AbortError', 'NotReadableError', 'NotFoundError', 'NotAllowedError'].includes(e.name)){
              d.state = 'error';
              d.deviceId = null;
            }

            console.error('[%s] %o: %o', deviceType, e, d);
          }
          break
        }
      }
      this.$emit('onUpdatePreview', {deviceType, device: this.selectedDevice[deviceType]});
    },
    async deviceTestComplete() {
      return new Promise((resolve, reject) => {
        DetectRTC.load(() => {
          const cameraPermission = DetectRTC.isWebsiteHasWebcamPermissions;
          const micPermission = DetectRTC.isWebsiteHasMicrophonePermissions;

          if(cameraPermission && micPermission){
            console.log('has device permission')
            resolve();
            return;
          }

          let text = '';
          let okText = '';

          if(this.enabled && this.deviceRequired){
            if(!cameraPermission || !micPermission){
              this.$alert({
                title: this.$t('common.alert.title'),
                text: this.$t('deviceSetting.essential'),
                class: 'device-authority',
                imgSrc: require('@/assets/roomType/lms/img/img-device-authority.png'),
                onlyOk: true
              });
              this.ENTER_REQUESTED(false)
            }
          }else{
            const n_has = [], n_perm = [];
            const msg = [];
            if(DetectRTC.videoInputDevices.length == 0){
                n_has.push(this.$t('common.device.camera'));
            }else if(!DetectRTC.isWebsiteHasWebcamPermissions){
                n_perm.push(this.$t('common.device.camera'));
            }
            if(DetectRTC.audioInputDevices.length == 0){
                n_has.push(this.$t('common.device.mic'));
            }else if(!DetectRTC.isWebsiteHasMicrophonePermissions){
                n_perm.push(this.$t('common.device.mic'));
            }
            if(DetectRTC.audioOutputDevices.length == 0){
                n_has.push(this.$t('common.device.speaker'));
            }
            if(n_has.length > 0){
                msg.push(
                    this.$t('deviceSetting.preview.device.notConnected', { '0' : n_has.join(', ') })
                );
            }
            if(n_perm.length > 0){
                msg.push(
                  this.$t('deviceSetting.preview.device.noRole', { '0' : n_perm.join(', ') })
                );
            }
            if(msg.length > 0){
              text = msg.join('<br>');
              okText = this.$t('deviceSetting.preview.device.without', { '0' : n_has.concat(n_perm).join(', ') });
            }

            // if(DetectRTC.videoInputDevices.length == 0 && DetectRTC.audioInputDevices == 0){
            //   text = '현재 사용할 수 있는 카메라 및 마이크 장치가 없습니다.';
            //   okText = '카메라, 마이크 없이 강의실 입장';
            // }else if(DetectRTC.videoInputDevices.length == 0){
            //     text = '현재 사용할 수 있는 카메라 장치가 없습니다.';
            //     okText = '카메라 없이 강의실 입장';
            // }else if(DetectRTC.audioInputDevices.length == 0){
            //     text = '현재 사용할 수 있는 마이크 장치가 없습니다.';
            //     okText = '마이크 없이 강의실 입장';
            // }
            // else if(!cameraPermission && !micPermission){
            //   text = '현재, 카메라 및 마이크를 사용할 수 없는 상태입니다.<br>브라우저에서 마이크와 카메라 권한을 허용해주세요';
            //   okText = '카메라, 마이크 없이 강의실 입장';
            // }else if(!cameraPermission){
            //   text = '현재, 카메라를 사용할 수 없는 상태입니다.<br>브라우저에서 카메라 권한을 허용해주세요';
            //   okText = '카메라 없이 강의실 입장';
            // }else if(!micPermission){
            //   text = '현재, 마이크를 사용할 수 없는 상태입니다.<br>브라우저에서 마이크 권한을 허용해주세요';
            //   okText = '마이크 없이 강의실 입장';
            // }

            this.$alert({
              title: this.$t('deviceSetting.preview.device.check'),
              text: text,
              class: 'device-authority',
              imgSrc: require('@/assets/roomType/lms/img/img-device-authority.png'),
              okText: okText,
              ok: resolve
            });
          }
        });
      });
    },
    onClose() {
      this.$modal('RoomDeviceSettingModal')
    },
    keymap(e) {
      // switch (e.keyCode) {
      //   case 13:
      //     this.applyChangedDevice()
      //     break
      //   case 27:
      //     this.closeModal()
      //     break
      // }
    },
    async setVirtualBackground(stream) {
      let type = this.selectedDevice.video.virtualBackgroundType;
      if (type === 'none'
          || stream.getVideoTracks().length === 0) {
        return Promise.resolve(stream)
      }
      const mediapipe = await RoomMediapipe.getSubMediapipe()
      await mediapipe.setStream(stream)

      // try{
      //   return await await mediapipe.setBackgroundByType({
      //     type,
      //     url: this.selectedDevice.video.virtualBackgroundUrl
      //   })
      // }catch (e) {
      //   this.resetVirtualBackground();
      // }

      if(type === 'blur'){
        return mediapipe.setBlurBackground();
      } else{
        let img;

        if (['blob:', 'data:'].some(imgType => type.startsWith(imgType))) {
          img = type // file url typeect
        } else if (type === 'custom') {
          img = this.selectedDevice.video.virtualBackgroundUrl;
        } else  {
          img = require(`@/assets/images/virtual-background/virtual_background_${type}.jpg`);
        }

        return mediapipe.setBackgroundImage({
          img,
        }).catch(async e => {
          this.resetVirtualBackground();
          throw e;
        });
      }
    },
    toggleNoiseCancel(e) {
      if(!this.isNoiseCancelAvailable){
        let text = this.roomInfoSetting.useNoiseCancel ? "" : this.$t('deviceSetting.preview.noiseCancelNotActivated')
        this.$alert(text + this.$t('deviceSetting.preview.noiseCancelError'));
        e.target.checked = false;
      }
    },
    onToggleAudioTest() {
      if (this.selectedDevice.audio.state !== 'success' || this.selectedDevice.audiooutput.state !== 'success') {
        this.$alert(this.$t('deviceSetting.preview.device.error'));
        return;
      }
      this.isShowAudioTest = !this.isShowAudioTest
    },
    togglePreviewMirror() {
      this.selectedDevice.video.usePreviewMirror = !this.selectedDevice.video.usePreviewMirror;
    },
    join() {
      if (this.enabled) {
        this.$emit('reqApproveJoin');
      } else {
        this.$emit('reqJoin');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.device-setting-preview-component {
  height: 100%;
}
.device-setting-preview {
  height: 100%;
}
.device-set-preview {
  width: 400px;
  height: 100%;
  padding: 32px 44px;
  position: relative;
}
.device-set-preview-header {}
.device-set-preview-title-wrapper {
  text-align: center;
  justify-content: center;
}
.device-set-preview-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  line-height: 22px;
}
.device-set-preview-body {
  margin-top: 24px;
}
.device-set-preview-video-container {
  width: 312px;
  height: 175px;
  position: relative;
}
.device-set-preview-video-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.device-set-preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scaleX(1);
  &.mirror {
    transform: scaleX(-1);
  }
}
.device-set-preview-status {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.device-set-preview-status-header {
  position: absolute;
  top:0;
  right: 0;
  left: 0;
}
.device-set-preview-status-warning-wrapper {
  padding: 7px 19px;
  background-color: #fb3030;
}
.device-set-preview-status-warning {
  font-size: 11px;
  color: #fff;
  line-height: 15px;
  text-align: center;
}
.device-set-preview-status-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
}
.device-set-preview-status-controls {
  padding-bottom: 12px;
  display: flex;
  justify-content: center;
}
.device-set-preview-status-control {
  width: 32px;
  height: 32px;
  margin-left: 12px;
  border-radius: 100%;
  pointer-events: none;
  &:first-of-type {
    margin-left: 0;
  }
  &.mic {
    background: rgba(0, 0, 0, 0.6) url('~@/assets/images/mic_on_white.svg') no-repeat center / 16px auto;

    &.off {
      background: rgba(0, 0, 0, 0.6) url('~@/assets/images/mic_off_red.svg') no-repeat center / 16px auto;
    }
  }
  &.camera {
    background: rgba(0, 0, 0, 0.6) url('~@/assets/images/cam_on_white.svg') no-repeat center / 16px auto;

    &.off {
      background: rgba(0, 0, 0, 0.6) url('~@/assets/images/cam_off_red.svg') no-repeat center / 16px auto;
    }
  }
}
.device-set-preview-options-container {
  margin-top: 8px;
}
.device-set-preview-options-header {}
.device-set-preview-options-tabs {
  display: flex;
  position: relative;
  &::after {
    content: '';
    width: 50%;
    height: 3px;
    background-color: #59f;
    position: absolute;
    right: 0;
    bottom: 0;
    transition: 0.1s ease-out;
  }
  &.video { &::after { left: 0 } }
  &.audio { &::after { left: 50% } }
}
.device-set-preview-options-tab-btn {
  flex: 1;
  line-height: 48px;
  font-size: 13px;
  font-weight: 700;
  color: #333;
  text-align: center;
  position: relative;
  &::before {
    content: '';
    width: 100%;
    height: 1px;
    background-color: #f4f4f4;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
.device-set-preview-options-body {
  margin-top: 20px;
}
.device-set-preview-footer {
  position: absolute;
  right: 44px;
  bottom: 32px;
  left: 44px;
}
.device-set-preview-help-container {
  margin-top: 15px;
  display: flex;
}
.device-set-preview-help-text {
  font-size: 12px;
  color: #666;
}
.device-set-preview-help-link {
  margin-left: 8px;
  font-size: 12px;
  color: #267dff;
  text-decoration: underline;
  &:hover {
    color: #59f !important;
  }
}
.device-set-preview-option-section {
  margin-top: 36px;
  position: relative;
  &:first-of-type {
    margin-top: 0;
  }
}
.device-set-preview-option-mic-speaker-test-btn-wrapper {
  text-align: center;
}
.device-set-preview-option-mic-speaker-test-btn {
  padding: 0 12px;
  border-radius: 30px;
  background-color: #f0f6ff;
  font-size: 12px;
  color: #247bff;
  line-height: 35px;
  transition: 0.2s ease-out;
  &:hover {
    background-color: #bdd7ff;
  }
}
.device-set-preview-option-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  line-height: 19px;
  display: flex;
  align-items: center;
}
.device-set-preview-option-beta {
  margin-left: 4px;
  display: flex;
  align-items: center;
}
.device-set-preview-option-description {
  margin-top: 4px;
  font-size: 12px;
  color: #666;
  line-height: 16px;
}
.device-set-preview-option-body {
  margin-top: 12px;
}
.device-set-preview-option-video-mirror-container {
  margin-top: 12px;
}
.device-set-preview-option-virtual-background-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}
.device-set-preview-option-virtual-background-btn-wrapper {
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  opacity: 0.8;
  transition: opacity 0.1s ease-out;
  &:hover,
  &.selected {
    opacity: 1;
  }
}

.device-set-preview-option-virtual-background-btn {
  height: 50px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  opacity: 0.8;
  transition: 0.1s ease-out;
  &::after {
    content: '';
    border: 3px solid #59f;
    padding-top: calc(25% - 3px);
    padding-bottom: calc(25% - 3px);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    transition: 0.1s ease-out;
  }
  &.none {
    background: #898989 url('~@/assets/images/no_use_white.svg') no-repeat center / 22px auto;
  }
  &.blur {
    background: url('https://biz-cdn.gooroomee.com/files/web/images/vbg/thumb_virtual_background_blur.png') no-repeat center / cover;
  }
  @for $i from 1 to 5 {
    &.inside_0#{$i} {
      background: url('https://biz-cdn.gooroomee.com/files/web/images/vbg/thumb_virtual_background_inside_0#{$i}.png') no-repeat center / cover;
    }
  }
  @for $i from 1 to 3 {
    &.outside_0#{$i} {
      background: url('https://biz-cdn.gooroomee.com/files/web/images/vbg/thumb_virtual_background_outside_0#{$i}.png') no-repeat center / cover;
    }
  }
  &.custom {
    height: 100%;
    background-color: #f1f1f1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &::before {
      content: '';
      width: 12px;
      height: 12px;
      background: url('~@/assets/images/plus.svg') no-repeat center / 12px auto;
      position: absolute;
      opacity: 0.4;
    }
    &:hover {
      background-color: #E4E4E4;
    }
  }
  &.change {
    height: auto;
    border-radius: 4px;
    padding: 0 4px;
    background: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    font-weight: 500;
    color: #fff;
    line-height: 24px;
    position: absolute;
    right: 5px;
    bottom: 5px;
    cursor: pointer;
  }
  &.apply {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  &.selected {
    opacity: 1;
    &::after {
      opacity: 1;
      visibility: visible;
    }
  }
  &.hide {
    display: none;
  }
  &:hover {
    opacity: 1;
  }
}
.device-set-preview-option-disabled-wrapper {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
}
.device-set-preview-option-disabled-text {
  font-size: 14px;
  color: #666;
  line-height: 22px;
  text-align: center;
  white-space: pre-line;
}
.device-set-preview-option-mic-volume-wrapper {
  height: 16px;
  margin-top: 10px;
  padding-left: 24px;
  background: url('~@/assets/images/mic_on_blue.svg') no-repeat center left / 14px auto;
  display: flex;
  align-items: center;
}
.device-set-preview-option-mic-volume {
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: #ededed;
}
.device-set-preview-option-mic-volume-fill {
  width: 100%;
  height: 100%;
  background-color: #59f;
  transform: scaleX(0);
  transform-origin: center left;
  transition: 0.1s ease-out;
}
.device-set-preview-option-deep-hearing-container {
  margin-top: 10px;
}

// Form
.form-select {
  width: 100%;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 0 26px 0 8px;
  background: white url('~@/assets/images/arrow_down_triangular_filled.svg') no-repeat center right 8px / 8px auto;
  font-size: 13px;
  font-weight: 500;
  color: #4b4b4b;
  line-height: 34px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  appearance: none;
  cursor: pointer;
}

// Toggle
.toggle-btn-container {
  .toggle-btn {
    display: none;
    &:checked {
      & + .toggle-label {
        .toggle-status {
          background-color: #59f;
          &::before {
            left: calc(100% - 16.5px);
          }
        }
      }
    }
  }
  .toggle-label {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
    .toggle-info {
      display: flex;
      align-items: center;
    }
    .toggle-label-text {
      font-size: 12px;
      font-weight: 400;
      color: #6a6a6a;
      &.deep-hearing {
        display: flex;
        align-items: center;
        &::after {
          content: '';
          width: 48px;
          height: 24px;
          margin-left: 8px;
          background: url('~@/assets/images/logo/deepHearing.png') no-repeat center / 100% auto;
          display: block;
        }
      }
    }
    .toggle-status {
      width: 36px;
      height: 18px;
      border-radius: 18px;
      background-color: #c4c4c4;
      position: relative;
      display: flex;
      align-items: center;
      cursor: pointer;
      pointer-events: auto;
      transition: 0.2s ease-out;
      &.disabled {
        opacity: 0.5;
      }
      &::before {
        content: '';
        width: 15px;
        height: 15px;
        border-radius: 100%;
        background-color: #fff;
        position: absolute;
        left: 1.5px;
        transition: 0.2s ease-out;
      }
    }
  }
}

// Description
.description-container {
  margin-left: 6px;
  .description-btn {
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background-color: #f1f1f1;
    font-size: 12px;
    font-weight: 700;
    color: #898989;
    cursor: auto;
    pointer-events: auto;
    &:hover {
      & + .description-modal {
        top: calc(100% + 2px);
        opacity: 1;
        visibility: visible;
      }
    }
  }
  .description-modal {
    border-radius: 4px;
    padding: 8px 10px;
    background-color: #333;
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    transition: 0.2s ease-out;
  }
  .description-text {
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    line-height: 16px;
  }
}

.device-set-preview-join-room-btn-wrapper {}

// Button
.default-btn {
  width: 100%;
  border-radius: 4px;
  background-color: $mainColor;
  font-size: 14px;
  font-weight: 700;
  color: $White;
  line-height: 52px;
  min-height: 52px;
  text-align: center;
  display: block;
  transition: 0.2s ease-out;
  &:hover {
    background-color: #1b59f6;
    color: $White !important;
    text-decoration: none !important;
  }
  &:focus {
    outline: none;
    color: $White !important;
    text-decoration: none !important;
  }
  &.home {
    display: none;
  }
}
.back-btn {
  width: 20px;
  height: 20px;
  background: url('~@/assets/images/arrowLineThickLeft.svg') no-repeat center / 12px auto;
  display: block;
  opacity: 0.6;
  transition: 0.2s ease-out;
  &:hover {
    opacity: 1;
  }
}

// Mobile
.mobile {
  display: none;
}

[grm-device-mobile] {
  .device-setting-preview-component {
    width: 100%;
  }
  .device-setting-preview {
    display: flex;
    flex-direction: column;
  }
  .device-set-preview-title-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .device-set-preview {
    width: 100%;
    height: 100%;
    margin: 60px 0 70px;
    padding: 0 24px;
    overflow-y: auto;
  }
  .device-set-preview-header {
    position: fixed;
    top: 24px;
    right: 24px;
    left: 24px;
  }
  .device-set-preview-body {
    margin-top: 0;
  }
  .device-set-preview-video-container {
    margin: 0 auto;
  }
  .device-set-preview-option-virtual-background-btn {
    height: auto !important;
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .device-set-preview-footer {
    background-color: #fff;
    position: fixed;
    right: 24px;
    left: 24px;
  }
  .device-set-preview-join-room-btn-wrapper {
    margin: 12px -44px -32px;
  }
  .mobile {
    min-width: auto !important;
    display: block;
  }
  .inRoom {
    .device-set-preview {
      padding: 0 24px;
    }
  }
}

// inRoom
.inRoom {
  .device-set-preview {
    width: auto;
    padding: 20px 30px 100px;
  }
  .device-set-preview-title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .device-set-preview-footer {
    right: 30px;
    bottom: 30px;
    left: 30px;
  }
}

// audio test
.device-setting-audio-test-component {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
}

/****************** Mobile ******************/
[grm-device-mobile]{
  .device-setting-audio-test-component {
    left: 0;
  }
}
</style>